
export default class CustomFunctions {
  /**
   * 初期化
   * @param options
   */
  constructor(options) {
    this.options = $.extend(options);
    this.init();
  }

  /**
   * 実行する
   */
  init() {
    this.searchFormModal();
    this.certificationSearch();
  }

  /**
   * カスタム関数
   */

  // headerのフォーム
  searchFormModal() {
    const triggerbtnName = ".js-header-searchform-open";
    const contentName = ".js-header-searchform-content";
    // const closebtnName = ".js-header-searchform-close";
    const $triggerbtn = $(triggerbtnName);
    const $content = $(contentName);
    // const $closebtn = $(closebtnName);

    $triggerbtn.click(function (e) {
      //トリガーボタンを押したときの動作
      if($("body").hasClass('is-search-modal-open')){
        $("body").removeClass("is-search-modal-open");
        $triggerbtn.removeClass("is-active");
      }else{
        $("body").addClass("is-search-modal-open");
        $triggerbtn.addClass("is-active");
      }
    });
    $(document).on('click', function(e) {
      //bodyに.is-search-modal-openがついているときに、
      //検索フォーム本体でもトリガーボタンでも無い要素が押されたら
      if(!$(e.target).closest(contentName).length && !$(e.target).closest(triggerbtnName).length){
        if($("body").hasClass('is-search-modal-open')){
          //bodyの.is-search-modal-openと、トリガーボタンの.is-activeを外す
          $("body").removeClass("is-search-modal-open");
          $triggerbtn.removeClass("is-active");
        }
      }
    });
  }

  // ループスライダー
  infiniteSlider() {
    const optionInfinite = {
      infinite: true,
      arrows: false,
      swipe: false,
      dots: false,
      variableWidth: true,  // スライド幅の自動計算を無効
      autoplay: true,
      autoplaySpeed: 0,
      speed: 5000,
      cssEase: "linear",
      pauseOnFocus: false,
      pauseOnHover: false
    }
    const slickInfinite = $('.js-infinite-slider');
    if (slickInfinite) $(slickInfinite).slick(optionInfinite);
  }


  // 認定事業者一覧 検索ボックス
  certificationSearch() {
    $('.c-certification-output__list-item').hide();
    $('.js-certification-area-child').hide();
    $('.js-certification-area-child-box').hide();
    // フリーワード入力
    const freeword = ".js-certification-freeword";
    const freewordOutput = '[data-output-box="freeword"]';
    const freewordOutputText = '[data-output="freeword"]';
    
    $(freeword).on('input', function () {
      if($(this).val() == ''){
        $(freewordOutput).hide();
      } else {
        $(freewordOutput).show();
        $(freewordOutputText).text($(this).val());
      }
    });

    // チェックボックスイベント
    function checkEvent(group) {
      var check = 'input[data-group="' + group + '"]';
      var checkAll = $('.js-certification-check-all[data-target="' + group + '"]');
      var checkOutput = '[data-output-box="' + group + '"]';
      var checkOutputText = '[data-output="' + group + '"]';

      var selectedItems = $(check + ':checked').map(function () {
          return $(this).val();
      }).get().join(', ');

      if(selectedItems == '') {
        $(checkOutputText).text('');
        $(checkOutput).hide();
      } else {
        $(checkOutput).show();
        $(checkOutputText).text('選択中');
        // $(checkOutputText).text(selectedItems); //リアルタイムで出す場合
      }
      // console.log(selectedItems);

      if(group == 'areaChild'){
        var allCheckFlag = true;
        $('input[data-group="areaParent"]:checked').each(function (){
          var targetGroup = $(this).data("target");
          if($('input[name="' + targetGroup + '[]"]:checked').length != $('input[name="' + targetGroup + '[]"]').length){
            allCheckFlag = false;
          }
        });
        // if (allCheckFlag == true) {
        //   $(checkAll).prop('checked', true);
        // } else {
        //   $(checkAll).prop('checked', false);
        // }
      } else {
        if ($(check + ':checked').length == $(check).length) {
          $(checkAll).prop('checked', true);
        } else {
          $(checkAll).prop('checked', false);
        }
      }
    }

    // function areaChildEvent() {
    // }

    // 親エリア選択リスト
    function areaParentEvent(el) {
      console.log("Parent");
      var target = el.data('target');
      var checkStatus = el.prop("checked");
      if(checkStatus == true) {
        $('.js-certification-area-child[data-id="' + target + '"]').slideDown();
        // 親エリアに紐づく子エリアを全てチェック
        $('.js-certification-area-child[data-id="' + target + '"]').find('input:checkbox').prop('checked', true);
        // 全て選択をチェック
        $('.js-certification-check-all[data-target="areaChild"]').prop('checked', true);
        checkEvent('areaChild');
      } else {
        $('.js-certification-area-child[data-id="' + target + '"]').slideUp();
        $('input[name="' + target + '"]').prop('checked', false);
        checkEvent('areaChild');
      }
    }

    // チェックボックスをクリックした時
    $('input[type="checkbox"]').on('change', function () {
      //すべて選択をチェックした場合
      if ($(this).hasClass('js-certification-check-all')) {
        var group = $(this).data('target');
        var checkStatus = $(this).prop("checked");
        if(group == "areaChild"){
          $('input[name="' + group + '"]:checkbox').prop('checked', false);
          $('input[data-group="areaParent"]:checked').each(function (){
            var targetGroup = $(this).data("target");
            if(checkStatus == true) {
              $('input[name="' + targetGroup + '[]"]:checkbox').prop('checked', true);
            } else {
              $('input[name="' + targetGroup + '[]"]:checkbox').prop('checked', false);
            }
          });
          checkEvent('areaChild');
        } else {
          if(checkStatus == true) {
            $('input[data-group="' + group + '"]:checkbox').prop('checked', true);
          } else {
            $('input[data-group="' + group + '"]:checkbox').prop('checked', false);
          }
          checkEvent(group);
        }
      //親エリアをチェックした場合
      } else if ($(this).data('group') == 'areaParent') {
        if($('input[data-group="areaParent"]:checked').length == 0) {
          $('.js-certification-area-child-box').slideUp();
          
        } else {
          // $parentAllCheck = $('.js-certification-check-all[data-target="areaChild"]')
          // console.log($parentAllCheck);
          $(".js-certification-area-child-box").slideDown();
        }
        areaParentEvent($(this));
      } else {
        checkEvent($(this).data('group'));
      }
    });

    // チェックボックスの「解除」をクリックした時のイベント
    const checkClear = $('.js-certification-check-clear');
    $(checkClear).on('click', function () {
        var group = $(this).data('target');
        $('[data-output="' + group + '"]').text('');
        $('input[data-group="' + group + '"]:checkbox').prop('checked', false);
        $('.js-certification-check-all[data-target="' + group + '"]').prop('checked', false);
        checkEvent(group)
    });

    // 全ての条件をクリアをクリックした時のイベント
    const allClear = $('.js-certification-all-clear');
    $(allClear).on('click', function () {
        $('.c-certification-output__list-item').hide();
        $('.js-certification-output-text').text('');
        $('.js-certification-freeword').val('');
        $('input:checkbox').prop('checked', false);
        $('.js-certification-area-child-box').slideUp();
        // checkEvent(group);
    });
  }
}